import ajax from '@/api/http';

//一级tabs
export function getTabsOne() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "CUSTOMER_QUERY_TYPE1"
    }
  })
}

//二级tabs
export function getTabsTwo() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "CUSTOMER_QUERY_TYPE2"
    }
  })
}

//一级tabs(业务员)
export function getSalesmanTabsOne() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "AGENT_CUSTOMER_QUERY_TYPE"
    }
  })
}

// 跟进状态
export function getFollowUpStatusList() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "FOLLOW_STATUS"
    }
  })
}

// 客户需求
export function getCustomerDemand() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "SUBSCRIBE_DEMAND"
    }
  })
}

// 为谁配置保险
export function getConfigInsurance() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "SUBSCRIBE_RELATION"
    }
  })
}

export function getFamilyInsureRelations() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "RELATION"
    }
  })
}

// 沟通方式
export function getCommunicateType() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "FOLLOW_TYPE"
    }
  })
}

// 证件类型
export function getCardType() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "CARD_TYPE"
    }
  })
}

// 家庭关系
export function getFamilyRelations() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "MARITAL_STATUS"
    }
  })
}

// 健康状况
export function getHealth() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "CUSTOMER_HEALTH"
    }
  })
}

// 获取团队
export function getOrganizationBase() {
  return ajax({
    type: "POST",
    url: `/buz/organizationBase/read/tree`,
    data: {
      source:1,
    },
  })
}

// 文件上传
export function upLoadFile(data, onUploadProgress) {
  return ajax({
    type: "POST",
    url: `/upload/common`,
    data,
    onUploadProgress
  })
}

